import { Form } from "antd";
import { FormModal } from "@/shared/components/FormModal";
import { useCreateGpsDevice, useUpdateGpsDevice } from "../hooks/useGpsDevices";
import { useGpsDevicesStore } from "../store/gps-devices.store";
import type { CreateGpsDeviceRequest, UpdateGpsDeviceRequest } from "../types";
import { GpsDeviceForm } from "./GpsDeviceForm";

interface GpsDeviceFormModalProps {
	organizationId: string;
}

export function GpsDeviceFormModal({ organizationId }: GpsDeviceFormModalProps) {
	const [form] = Form.useForm<CreateGpsDeviceRequest>();
	const { modalOpen, editingDevice, closeModal } = useGpsDevicesStore();

	const { mutate: createGpsDevice, isPending: isCreating } = useCreateGpsDevice();
	const { mutate: updateGpsDevice, isPending: isUpdating } = useUpdateGpsDevice();

	const handleClose = () => {
		closeModal();
		form.resetFields();
	};

	const handleUpdate = (values: Partial<CreateGpsDeviceRequest>) => {
		if (!editingDevice) {
			return;
		}

		const updateData: UpdateGpsDeviceRequest = {};
		if (values.imei !== undefined && values.imei !== editingDevice.imei) {
			updateData.imei = values.imei;
		}
		if (values.equipmentId !== editingDevice.equipmentId) {
			updateData.equipmentId = values.equipmentId;
		}
		if (values.status !== editingDevice.status) {
			updateData.status = values.status;
		}

		updateGpsDevice({ id: editingDevice.id, data: updateData }, { onSuccess: handleClose });
	};

	const handleSubmit = () => {
		form.validateFields().then((values) => {
			const payload = {
				...values,
				organizationId: editingDevice?.organizationId ?? organizationId,
			};
			if (editingDevice) {
				handleUpdate(payload);
			} else {
				createGpsDevice(payload as CreateGpsDeviceRequest, { onSuccess: handleClose });
			}
		});
	};

	return (
		<FormModal
			title="Yangi GPS qurilma"
			editTitle="GPS qurilmani tahrirlash"
			editing={!!editingDevice}
			open={modalOpen}
			onCancel={handleClose}
			onOk={handleSubmit}
			confirmLoading={isCreating || isUpdating}
			width={500}
		>
			<GpsDeviceForm form={form} organizationId={editingDevice?.organizationId ?? organizationId} />
		</FormModal>
	);
}
